var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRubricsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7861 1.94348V25.5345M19.6328 1.94348V25.5345M1.93945 9.31569H28.4794M1.93945 18.1623H28.4794M6.65767 25.5345H23.7612C25.4127 25.5345 26.2385 25.5345 26.8693 25.2131C27.4241 24.9305 27.8753 24.4793 28.158 23.9245C28.4794 23.2937 28.4794 22.4679 28.4794 20.8163V6.66169C28.4794 5.01017 28.4794 4.1844 28.158 3.5536C27.8753 2.99872 27.4241 2.5476 26.8693 2.26489C26.2385 1.94348 25.4127 1.94348 23.7612 1.94348H6.65767C5.00613 1.94348 4.18037 1.94348 3.54957 2.26489C2.9947 2.5476 2.54358 2.99872 2.26087 3.5536C1.93945 4.1844 1.93945 5.01016 1.93945 6.66169V20.8163C1.93945 22.4679 1.93945 23.2937 2.26087 23.9245C2.54358 24.4793 2.9947 24.9305 3.54957 25.2131C4.18037 25.5345 5.00613 25.5345 6.65767 25.5345Z",
    stroke: "#52565A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubricsIcon);
export default __webpack_public_path__ + "static/media/RubricsIcon.3c394554a3b8f4c0a755444d45a67877.svg";
export { ForwardRef as ReactComponent };